<template>
  <div class="container row">
    <div class="nav">
      <div class="nav-content row">
        <div class="title">
          <div>{{info.title}}</div>
        </div>
        <div class="oporation row">
          <div class="download" @click="download()"></div>
        </div>
      </div>
    </div>
    <div class="main row">
      <pdf ref="pdf" class="pdf" v-if="info" :goToPage="goToPage" :go="go" :link="info.url" @pdfInitReady="pdfInitReady"></pdf>
    </div>
    <BackTop></BackTop>
    <div class="amplification" @click="onAmplificationClick"></div>
    <div class="shrink" @click="onShrinkClick"></div>
  </div>
</template>
  
<script>
import authService from '@/services/authService';
import Pdf from '@/components/common/Pdf';
import QuestionQuery from '@/rest/questionQuery';
import BackTop from '@/components/common/PdfBackTop';

export default {
  name: 'PdfDetail',
  data() {
    return {
      info: null,
      goToPage: 1,
      go: false
    };
  },
  methods: {
    onBackTopClick() {

    },
    onAmplificationClick() {
      this.$refs.pdf.amplificationPdf();
    },
    onShrinkClick() {
      this.$refs.pdf.shrinkPdf();
    },
    download() {
      const fileName = this.info.title.replace(/[.|\\|/|*|?|"|<|>||]/g, '').replace(/:/g, '：');
      QuestionQuery.getPdfDownload(this.info.url, fileName, this.info.source, /\d{4}-\d{1,2}-\d{1,2}/g.exec(this.info.date));
    },
    goToPdfPage(page) {
      // 工具函数 - 跳转到 pdf 某一页
      this.goToPage = page;
      this.$nextTick(() => {
        this.go = !this.go;
      });
    },
    pdfInitReady() {
      // pdf 实例初始化完成，跳转到指定页码位置
      // （当且仅当 info.page 字段不为空，也就是从图片搜素跳转过来详情页才会有 info.page 字段）
      // this.info.page = 3
      // ⬆️ 上一行为测试用代码
      if (this.info && this.info.figure_page && this.info.figure_page - 0) {
        this.goToPdfPage(this.info.figure_page - 0);
      }
    }
  },
  created() {
    // 页面 created 的时候从主页拿到详细数据
    this.info = JSON.parse(authService.getPdfDetailData());
    document.title = this.info.title;
  },
  components: {
    Pdf,
    BackTop
  }
};
</script>
  
<style lang="scss" scoped>

.container {
  flex-direction: column;
  align-items: center;
  width: 100vw;
  min-width: 1200px;
  box-sizing: border-box;
  .nav {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    width: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    flex-shrink: 0;
    z-index: 2;
    .nav-content {
      width: 1200px;
      padding-right: 20px;
      margin: 0 auto;
      justify-content: space-between;
      align-items: center;
    }
    .title {
      flex-shrink: 0;
      color: #171f46;
      min-width: 10px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .oporation {
      align-items: center;
      width: 35px;
      .time {
        flex-shrink: 0;
        color: #ffffff;
      }
      .download {
        flex-shrink: 0;
        margin-left: 16px;
        width: 14px;
        height: 14px;
        background: url('../assets/img/download-fff.svg') center center;
        cursor: pointer;
        &:hover {
          background: url('../assets/img/download-hover.svg') center center;
        }
      }
    }
  }
  .main {
    justify-content: space-between;
    margin-top: 40px;
    padding: 24px 0 50px 0;
    min-height: calc(100vh - 60px);
    min-width: 1200px;
    box-sizing: border-box;
    overflow: hidden;
    .pdf {
      margin: 0 auto;
      width: 800px;
      height: 100%;
      background-color: #fff;
    }
    .right {
      width: 378px;
      height: 100%;
      background-color: #fff;
      .search-nav {
        padding: 12px 16px;
        justify-content: start;
        flex-wrap: wrap;
        align-items: center;
        min-height: 48px;
        box-shadow: inset 0px -1px 0px 0px #f2f3f7;
        box-sizing: border-box;
      }
      .search-items {
        padding: 16px;
        width: 100%;
        height: calc(100% - 48px);
        box-sizing: border-box;
        overflow: scroll;
        .item-container {
          padding: 10px 0;
          border-bottom: 1px dotted #e5e6ee;
        }
      }
    }
  }
  .amplification {
    position: fixed;
    bottom: 131px;
    right: 79px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: #ffffff;
    background-image: url("../assets/img/amplification.svg") ;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    &:hover{
      background-color: #45a8cc;
      background-image: url("../assets/img/amplification-hover.svg") ;
    }
  }
  .shrink {
    position: fixed;
    bottom: 81px;
    right: 79px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: #ffffff;
    background-image: url("../assets/img/shrink.svg") ;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    &:hover{
      background-color: #45a8cc;
      background-image: url("../assets/img/shrink-hover.svg") ;
    }
  }
}

/deep/.collect-dialog {
  .dialog-content {
    overflow-y: auto;
    max-height: 160px;
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 24px 24px 14px;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      max-height: 300px;
      overflow: auto;
      padding: 0 24px 16px;
    }
    .el-dialog__footer {
      padding: 0 24px 24px;
    }
  }
}
.dialog-input {
  width: 352px;
  height: 32px;
  padding-left: 16px;
  border-radius: 2px;
  border: solid 1px #e5e6ee;
  color: #171f46;
  outline: none;
  &:hover {
    border: solid 1px #999ebe;
  }

  &:focus {
    border: solid 1px #171f46;
  }
}
.folder-name {
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 16px;
  width: 352px;
  height: 32px;
  line-height: 32px;
  color: #747990;
  background-color: rgba(0, 11, 92, 0.03);
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.06);
  }
}
.selected-folder-name {
  color: #171f46;
  background-color: rgba(0, 11, 92, 0.06);
}
.dialog-footer {
  justify-content: space-between;
  .btn {
    height: 32px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
  }
  .new-favorites-btn {
    width: 102px;
    color: #747990;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
    background-blend-mode: normal, normal;
    }
  }
  .cancel-btn {
    width: 60px;
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
  }
  .confirm-btn {
    width: 60px;
    color: #ffffff;
    background-color: #0055ff;
    &:hover {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
  }
}
</style>
